module.exports = __webpack_public_path__ + "img/szhx_titIcon5.fc02d346.png";